<template>
  <div class="box">
    <el-alert
      title="法人创建企业后，自动成为企业管理者，并生成对应企业名称的公章，拥有员工认证管理权限"
      type="warning"
      :closable="false"
      show-icon
    >
    </el-alert>
    <div class="content">
      <img class="img" src="@/assets/image/home/qiyeshiming/none.webp" alt="" srcset="" />
      <div class="text1">
        未搜索到
        <span>「{{ chaxunData.name }}」</span>
      </div>
      <div class="btns">
        <el-button class="button" plain type="primary" @click="onback">上一步</el-button>
        <el-button class="button" type="primary" @click="onnext">创建企业</el-button>
      </div>
      <div class="text2">
        <span>仅企业法人具备在平台创建企业的权限。</span>
        企业法人完成创建后，其他账号方可搜索到企业，并完成认证。
      </div>
    </div>
    <messageDialog ref="messageDialogRef" />
  </div>
</template>

<script>
import mixins from "./mixins";
import messageDialog from "@/components/messageDialog/messageDialog.vue";
import userinfo from "@/mixins/userinfo.js";
export default {
  components: {
    messageDialog,
  },
  mixins: [mixins, userinfo],
  data() {
    return {};
  },
  created() {},
  computed: {},
  methods: {
    async getCompanyInfo() {
      const { data, info, status } = await this.$api.getCompanyInfo({
        companyName: this.chaxunData.name,
      });
      console.log(this.user.name);
      if (status === 200) {
        if (data.error_code === 0) {
          const { faRen, creditCode, companyName } = data.result;
          if (faRen === this.user.name) {
            this.$router.push({
              path: "/auth/CompanyAuth",
              query: {
                name: companyName,
                idNumber: creditCode,
                representativeName: faRen,
              },
            });
            this.hideMode2();
            return
          }
        }
        this.$refs.messageDialogRef.onShow();
      } else {
        this.$message.error(info);
      }
    },
    onnext() {
      this.getCompanyInfo();
    },
    onback() {
      this.setStep("chaxun");
    },
  },
};
</script>

<style scoped lang="scss">
.box {
  @include alertStyle;

  padding: 0 16px;
  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 226px;

    .img {
      width: 200px;
      height: 108px;
    }
    .btns {
      margin-top: 40px;
      .button {
        margin-top: 16px;
        &::v-deep {
          @include buttonStyle2;
        }
      }
    }
    .text1 {
      font-family: Source Han Sans;
      font-size: 14px;
      font-weight: 350;
      line-height: normal;
      text-align: center;
      letter-spacing: 0em;

      font-variation-settings: "opsz" auto;
      font-feature-settings: "kern" on;
      /* 未搜索到 */
      color: #999999;
      margin-top: 16px;
      span {
        color: #262626;
      }
    }
    .text2 {
      font-family: Source Han Sans;
      font-size: 14px;
      font-weight: 350;
      line-height: normal;
      text-align: center;
      letter-spacing: 0em;

      font-variation-settings: "opsz" auto;
      font-feature-settings: "kern" on;
      /* 仅企业法人具备在平台创建企业的权限。 */
      color: #262626;
      margin-top: 16px;
      span {
        color: #f53f3f;
      }
    }
  }
}
</style>
